import React from "react";
import CartItem from "./CartItem";
import { Badge, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getCart } from "../../../Redux/Customers/Cart/Action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const jwt = localStorage.getItem("jwt");
  const { cart } = useSelector((store) => store);


  useEffect(() => {
    dispatch(getCart(jwt));
  }, [jwt]);

  const showError = (errMessage) => {
    toast.error(errMessage);
  };

  return (
    <div className="mt-7 mb-9">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        // transition="Flip"
      />
      {cart.cartItems.length > 0 && (
        <div className="lg:grid grid-cols-3 lg:px-16 relative">
          <div className="lg:col-span-2 lg:px-5">
            <div className="space-y-3">
              {cart.cartItems.map((item) => (
                <>
                  <CartItem
                    item={item}
                    showButton={true}
                    showError={showError}
                  />
                </>
              ))}
            </div>
          </div>
          <div className="px-5 sticky top-0 h-[100vh] mt-5 lg:mt-0 ">
            <div className="border p-5 shadow-lg rounded-md">
              <p className="font-bold pb-4 text-[#B28585]">PRICE DETAILS</p>
              <hr />

              <div className="space-y-3 font-semibold">
                <div className="flex justify-between pt-3 text-[#B28585]">
                  <span>Price ({cart.cart?.totalItem} item)</span>
                  <span>₹{cart.cart.totalPrice.toFixed(2)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#B28585]">Discount</span>
                  <span className="text-red-500">
                    -₹{cart.cart?.discount.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#B28585]">Delivery Charges</span>
                  <span className="text-red-500">Free</span>
                </div>
                <hr />
                <div className="flex justify-between font-bold text-lg">
                  <span className="text-[#B28585]">Total Amount</span>
                  <span className="text-red-500">
                    ₹{cart.cart?.totalDiscountedPrice.toFixed(2)}
                  </span>
                </div>
              </div>

              <Button
                onClick={() => navigate("/checkout?step=2")}
                variant="contained"
                type="submit"
                sx={[
                  {
                    "&:hover": {
                      backgroundColor: "#b98f8f !important",
                    },
                  },
                  {
                    padding: ".8rem 2rem",
                    backgroundColor: "#B28585",
                    width: "100%",
                    marginTop: "2rem",
                  },
                ]}
              >
                Check Out
              </Button>
            </div>
          </div>
        </div>
      )}
      {cart.cartItems.length == 0 && !cart?.loading && (
        <div className="flex flex-col justify-center items-center align-center">
          <img src="https://www.manyavar.com/on/demandware.static/-/Library-Sites-ManyavarSharedLibrary/default/dw6bd304a5/images/illustrations/empty.cart.gif" />
          <Typography
            variant="h6"
            sx={{
              marginBottom: 1,
              fontSize: 15,
              fontWeight: 600,
            }}
          >
            Your cart is empty
          </Typography>
          <Typography
            sx={{
              marginBottom: 3,
            }}
          >
            There are no items in your cart. Let’s add something
          </Typography>
          <Button
            className="px-3"
            onClick={() => {
              navigate("/");
              window.scrollTo(0, 0);
            }}
            sx={[
              {
                "&:hover": {
                  backgroundColor: "#ed113d !important",
                },
              },
              {
                padding: ".8rem 0",
                backgroundColor: "#f00",
                color: "#fff",
                widht: "100%",
                padding: "15px 50px",
                borderRadius: 1,
              },
            ]}
          >
            Continue Shopping
          </Button>
        </div>
      )}
    </div>
  );
};

export default Cart;
